import { GET_DOMAIN_LIST_SUCCESS, ADD_NEW_DOMAIN_FAILED, ADD_NEW_DOMAIN_SUCCESS, ADD_NEW_DOMAIN_REQUEST } from "../Actions/DomainAction";

const InitialState = {
    domainList: [],
    loading: false,
    success: false,
};

export const DomainReducer = (state = InitialState, action: any) => {
    switch (action.type) {

        case ADD_NEW_DOMAIN_REQUEST:
            return {
                ...state,
                loading: true
            };

        case ADD_NEW_DOMAIN_SUCCESS:
            return {
                ...state,
                loading: false,

                domainList: [...state.domainList, action.payload]
            };

        case ADD_NEW_DOMAIN_FAILED:
            return {
                ...state,
                loading: false,
            };

        case GET_DOMAIN_LIST_SUCCESS:
            return {
                ...state,
                domainList: action.payload,
            };

        default:
            return state;
    }
};